<div class="container-fluid" [hidden]="!showResults">
  <div class="row form-row">
    <div class="col-sm-12">
      <b>{{ 'profiles.profile-dup-checker.possible-existing-profiles' | translate | titlecase }}</b>
    </div>
  </div>
  <div class="profile-dup-checker-results-container" [ngClass]="{ 'profile-dup-checker-events-results': sourceModule == 'events' }">
    <wl-profile-results-grid [profiles]="profileResults" (onProfileSelected)="selectProfile($event)"> </wl-profile-results-grid>
  </div>
</div>
